<template>
    <v-dialog
      v-model="isOpen"
      scrollable
      persistent
      max-width="1000px"
    >
      <v-card>
        <v-toolbar flat dark color="rgb(51, 97, 137)">
          <v-spacer></v-spacer>
          <v-toolbar-title
            class="font-weight-light text-center ml-5 text-capitalize"
            >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.viewExam'
                )
            }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="overflow-unset">
          <div >
            <v-card outlined elevation="0" class="mt-5 card-color" >
              <v-toolbar
                outlined
                elevation="0"
                class=""
                color="grey lighten-4"
              >
                <v-col :cols="randomSetting ? 4 : 0" class="pl-0" :md="randomSetting ? 4 : 0" :sm="randomSetting ? 4 : 0" v-if="randomSetting">
                  <div>
                    <span class="pa-0">{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.numberOfQuestionsInLib'
                        )
                      }} :  </span>
                    <span class="pa-0">
                      {{questionInLib}}
                    </span>
                  </div>
                </v-col>
                <v-col :cols="randomSetting ? 4 : 9" class="pl-0" :class="randomSetting?'text-center':'text-left'" :md="randomSetting ? 4 : 9" :sm="randomSetting ? 4 : 9">
                  <div>
                    <span class="pa-0">{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.numberOfQuestions'
                        )
                      }} :  </span>
                    <span class="pa-0">
                      {{totalQuestion}}
                    </span>
                  </div>
                </v-col>

                <v-col :cols="randomSetting ? 4 : 3" class="text-right" :md="randomSetting ? 4 : 3" :sm="randomSetting ? 4 : 3">
                  <div><span>{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.score'
                        )
                      }} :  </span>
                    <span class="pa-0">
                      {{totalScore}}
                    </span>
                    <!-- <v-row>
                      <v-col cols="4" class="pl-0">จำนวนข้อทั้งหมด</v-col>
                        <v-col cols="10" class="pl-0">50</v-col>
                      </v-row>
                    </v-row> -->
                    </div>
                </v-col>
              </v-toolbar>
            </v-card>
          </div>
        </v-card-text>
        <v-card-text>
          <div v-for="qList in arrQuestion" :key="qList.id">
            <v-card outlined elevation="0" class="mt-5">
              <v-toolbar
                outlined
                elevation="0"
                class="py-4"
                color="grey lighten-4"
                height="auto"
                min-height="80"
              >
                <v-col cols="9" class="pl-0">
                  <v-toolbar-title class="custom-question">
                    <p class="mb-0">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.question'
                        )
                      }}
                      {{ ' ' + (qList.priority + 1) }}.<br/>
                      <span v-if="qList.articleQuestion" @click="openArticle(qList.articleQuestion)">
                        <span class="article-title">
                          {{$vuetify.lang.t('$vuetify.courseManagement.accessStep.manageLearners.reportExam.fromArticle')}}
                        </span>
                        <v-btn
                          color="primary"
                          depressed
                          small
                        >
                          <v-icon left>
                            mdi-file-document-outline
                          </v-icon>
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.article'
                            )
                          }}
                        </v-btn>
                      </span>
                      <span
                        v-html="qList.question"
                        class="font-weight-bold"
                      ></span>
                    </p>
                  </v-toolbar-title>
                  <span class="ssubtitle-2 grey--text">
                    ({{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.reportExam.typeExam'
                      )
                    }}: {{ question_type[qList.questionType] }})
                  </span>
                </v-col>

                <v-col cols="3">
                  <v-row>
                    <v-col class="pl-0 pt-5"
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.score'
                        )
                      }}
                      :</v-col
                    >
                    <v-col class="pa-0">
                      <v-text-field
                        class="mt-3"
                        v-model="qList.QuestionScore"
                        :disabled="qList.boolean == false"
                        single-line
                        outlined
                        type="number"
                        min="0"
                        background-color="white"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-toolbar>
              <v-card-text>
                <p
                  v-if="
                    qList.questionType == 'memorygame'
                  "
                  class="mb-0 success--text font-weight-black display-5"
                >
                  ข้อสอบนี้เป็นข้อสอบประเภทความจำ
                </p>

                <v-list
                  v-if="
                    qList.questionType == 'single'
                  "
                >
                  <v-list-item
                    v-show="
                      qList.choices[0].text && qList.choices[0].text != ''
                    "
                    v-for="(rowChoiceText, index) in qList.choices"
                    :key="rowChoiceText._id + '_quiz_tab'"
                  >
                    <v-list-item-icon class="custom-icon">
                      <!-- <v-icon
                              v-show="
                                qList.studentAnswer[0] == rowChoiceText._id
                              "
                              :color="
                                getstudentCorrectAnser(
                                  qList.studentAnswer[0],
                                  qList.correctAnswer[0]._id
                                ) == rowChoiceText._id
                                  ? 'success'
                                  : 'error'
                              "
                            >
                              {{
                                getstudentCorrectAnser(
                                  qList.studentAnswer[0],
                                  qList.correctAnswer[0]._id
                                ) == rowChoiceText._id
                                  ? 'mdi-check'
                                  : 'mdi-close'
                              }}
                            </v-icon> -->
                    </v-list-item-icon>

                    <v-list-item-content>
                      <div class="d-flex">
                        <div class="custom-number-panel">
                          <div
                            class="number-border"
                          >
                            <div class="number">{{ index + 1 }}</div>
                          </div>
                        </div>

                        <div class="pa-5 mr-5 have-border ml-10 full-width">
                          <p class="mb-0" v-html="rowChoiceText.text"></p>
                        </div>
                      </div>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon
                        :color="
                          qList.correctAnswer[0] == rowChoiceText._id
                            ? 'success'
                            : 'error'
                        "
                      >
                        {{
                          qList.correctAnswer[0] == rowChoiceText._id
                            ? 'mdi-check'
                            : 'mdi-close'
                        }}
                      </v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

                <div
                  v-if="
                    qList.questionType == 'multiple'
                  "
                >
                  <v-list>
                    <v-list-item
                      v-show="
                        qList.choices[0].text && qList.choices[0].text != ''
                      "
                      v-for="(rowChoiceText, index_choice) in qList.choices"
                      :key="rowChoiceText._id + '_quiz_tab'"
                    >
                      <v-list-item-content>
                        <div class="d-flex">
                          <div
                            class="custom-number-panel"
                          >
                            <div
                              class="number-border"
                            >
                              <div class="number">
                                {{ index_choice + 1 }}
                              </div>
                            </div>
                          </div>

                          <div class="pa-5 mr-5 have-border ml-10 full-width">
                            <p class="mb-0" v-html="rowChoiceText.text"></p>
                          </div>
                        </div>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon
                          :color="
                            chekCorrectAnswer(
                              rowChoiceText._id,

                              qList
                            ) == true
                              ? 'success'
                              : 'error'
                          "
                        >
                          {{
                            chekCorrectAnswer(
                              rowChoiceText._id,

                              qList
                            ) == true
                              ? 'mdi-check'
                              : 'mdi-close'
                          }}
                        </v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </div>

                <div
                  v-if="
                    qList.questionType == 'fillgaptext'
                  "
                >
                  <div class="mt-6">
                    <p class="font-weight-bold">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.examAnswer'
                        )
                      }}
                    </p>
                    <div class="have-border mt-3 pa-2">
                      <div
                        v-for="(correctText, index) in qList.correctText"
                        :key="index"
                      >
                        <p v-html="correctText"></p>
                        <v-divider
                          class="my-3"
                          v-show="
                            qList.correctText.length > 1 &&
                            index !== qList.correctText.length - 1
                          "
                        ></v-divider>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-show="
                    qList.questionType == 'matchsome'
                  "
                >
                  <div class="py-5 full-width">
                    <div
                      v-for="(questionMatch, index) in qList.questionMatch"
                      :key="index"
                    >
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                          <div class="mb-1">
                            <p class="font-weight-bold">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.accessStep.manageLearners.reportExam.topic'
                                )
                              }}
                              &nbsp; {{ index + 1 }}
                            </p>
                            <p class="mb-0" v-html="questionMatch"></p>
                          </div>

                          <p class="font-weight-bold">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.accessStep.manageLearners.reportExam.matchihng'
                              )
                            }}
                          </p>

                          <div
                            v-for="coices in qList.choices"
                            :key="coices._id"
                          >
                          <v-row>
                            <v-col>
                            <p v-html="coices.text"></p>
                            </v-col>
                            <!-- <v-list-item-action> -->
                              
                            <v-col>
                            <v-icon
                              :color="
                                findCorrectMatch(qList.correctMatch[index].correct,coices._id)
                                  ? 'success'
                                  : 'error'
                              "
                            >
                              {{
                                findCorrectMatch(qList.correctMatch[index].correct,coices._id)
                                  ? 'mdi-check'
                                  : 'mdi-close'
                              }}
                            </v-icon>
                            
                            </v-col>
                          </v-row>
                          <!-- </v-list-item-action> -->
                          </div>
                        </div>

                        <!-- <div>
                          <v-btn
                            class="ma-2"
                            @click="
                              showAnswer(
                                qList.correctMatch[index],
                                qList.choices
                              )
                            "
                            outlined
                            color="success"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.accessStep.manageLearners.reportExam.viewAnswer'
                              )
                            }}</v-btn
                          >
                        </div> -->
                      </div>
                      <v-divider
                        class="my-5"
                        v-show="index !== qList.questionMatch.length - 1"
                      ></v-divider>
                    </div>
                  </div>
                </div>

                <div
                  v-show="
                    (qList.questionType == 'wordsearch' ||
                      qList.questionType == 'crossword')
                  "
                >
                  <div class="mt-6">
                    <p class="font-weight-bold">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.examAnswer'
                        )
                      }}
                    </p>
                    <div class="have-border mt-3 pa-2">
                      <div
                        v-for="(correctText, index) in qList.correctPuzzleGrid"
                        :key="index"
                      >
                        <p v-html="correctText.text"></p>
                        <v-divider
                          class="my-3"
                          v-show="
                            qList.correctPuzzleGrid.length > 1 &&
                            index !== qList.correctPuzzleGrid.length - 1
                          "
                        ></v-divider>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="text-center">
            <v-pagination
              v-model="page_editScore"
              :length="pageCount_editScore"
              @input="changePageEditScore()"
              color="rgb(66, 154, 216)"
            ></v-pagination>
          </div>
        </v-card-text>
      </v-card>
      <v-dialog
        v-model="articleDialogStatus"
        scrollable
        persistent
        max-width="800px"
      >
        <v-card>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-spacer></v-spacer>
            <v-toolbar-title
              class="font-weight-light text-center ml-5 text-capitalize"
              >{{$vuetify.lang.t('$vuetify.courseManagement.accessStep.manageLearners.reportExam.fromArticle')}}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeArticleDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>

          <div
            class="pt-5 article-content"
            v-html="article"
            ref="articleContainer"
            id="articleContainer"
          ></div>
        </v-card-text>
        </v-card>
      </v-dialog>
    </v-dialog>
</template>

<script>
import moment from 'moment';
import {
  getExamReport,
} from '@/service/course/report';
import {
  getListQuestionExam,
} from '@/service/course/course';
import {
  getAdminTicketDetail
} from '@/service/course/exam.js';
export default {
  props: {
    ticketId:{
      type: String
    },
    isOpen: {
      type: Boolean
    },
    closeDialog: {
      type: Function
    }
  },
  watch: {
    isOpen: async function(newValue) {
      if (newValue) {
        console.log("Yes")
        this.initialize();
      }
    }
  },
  data() {
    return {
      loading: false,
      exam_item: [],
      dialogReportTicket: false,
      itemUserTicket: [],
      userTicket: [],
      users: [],
      idExam: '',
      itemExam: [],
      page_editScore: 1,
      arrQuestion: [],
      pageCount_editScore: 1,
      question_type: {
        single: 'ตัวเลือกเดียว',
        fillgaptext: 'เติมคำ',
        matchsome: 'จับคู่',
        multiple: 'หลายตัวเลือก',
        memorygame: 'เกมความจำ',
        crossword: 'เกมไขว้คำ',
        wordsearch: 'เกมหาคำ',
      },
      listTicketloading: false,

      params: {},
      pageCount: 1,
      examSelect: '',
      fullScore: 0,
      totalQuestion: 0,
      totalScore: 0,
      randomSetting: false,
      questionInLib: 0,

      //course info
      course_info: [],
      examReportDetail: [],

      countTerm: [],
      status_toggle: 0,
      articleDialogStatus: false,
      article: ""
    };
  },
  computed: {
    icon() {
      if (this.likesAllGroup) return 'mdi-checkbox-marked';
      if (this.likesSomeGroup) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },

    likesAllCountTerm() {
      return (
        this.countTerm.length === this.examReportDetail[0].countterm.length
      );
    },
    likesSomeCountTerm() {
      return this.countTerm.length > 0 && !this.likesAllCountTerm;
    },
  },
  methods: {
    async initialize() {
      this.params = {
        page: 1,
        limit: 5,
        // idexam: '',
        // groupnull: false,
      };
      // let idexam = this.exam_item[0]._id;
      // this.examName = this.exam_item[0].title
      // this.idExam = idexam;
      
      await this.getQuestionListExam();
    },

    openArticle(articleQuestion){
      this.articleDialogStatus = true
      this.article = articleQuestion.article
    },
    closeArticleDialog(){
      this.articleDialogStatus = false
      this.article = ""
    },
    
    findCorrectMatch(corrects,id){
      // console.log(corrects, id, corrects.findIndex(correct=> correct == id) > -1)
      let foundIndex = corrects.findIndex(correct=> correct == id)
      console.log(foundIndex)
      if(foundIndex > -1){
        return true
      }
      return false
    },

    async changePage(page) {
      this.params.page = page;
      await this.getReport();
    },
    getTime(time) {
      //let time_info = "";
      let h = new Date(time).getHours();
      let m = new Date(time).getMinutes();

      if (h < 10) {
        h = '0' + h;
      }

      if (m < 10) {
        m = '0' + m;
      }

      //time_info =
      // parseInt(h) < 9 ? "0" + h : h + ":" + parseInt(m) < 9 ? "0" + m : m;
      return h + ':' + m + ' น.';
    },
    async getReport() {
      this.loading = true;
      this.users = [];
      let result = await getExamReport(this.params);

      console.log(result)
      this.numberOfTakingExam = result.data.length;
      this.totalTakingExam = result.count;
      this.pageCount = result.maxPage;
      result.data.forEach((user) => {
        let info = {
          id: user.student._id,
          prefix: user.student.prefix,
          username: user.student.username,
          fullName: user.student.firstName + ' ' + user.student.lastName,
          email: user.student.email,
          note: user.student.school,
          statusFace: user.statusFace,
          countTicket: user.countTicket,
        };

        this.users.push(info);
      });
      this.loading = false;
    },
    async setLoadingTicketList(status){
      this.listTicketloading = status
    },
    async closeDialogUserTicket() {
      this.dialogReportTicket = false;
      this.userTicket = [];
      await this.getReport();
    },
    async getQuestionListExam() {
      let data = {
        ticketId: this.ticketId,
        page: this.page_editScore,
        limit: 10,
      };
      // let result = await getListQuestionExam(data);
      let result = await getAdminTicketDetail(data)
      console.log(result.result)
      // this.ticketId = resultTicketDetail
      // this.dialog_review = true
      // console.log(resultTicketDetail)

      this.arrQuestion = [];
      result.result.data.forEach((quiz) => {
        // if (quiz.typeQuestion != "article") {
        this.arrQuestion.push({
          articleQuestion: quiz.articleQuestion,
          priority: quiz.priority,
          id: quiz._id,
          question: quiz.question,
          questionType: quiz.typeQuestion,
          choices: quiz.choices,
          correctAnswer: quiz.correct,
          correctText: quiz.correctText,
          questionMatch: quiz.questionMatch,
          correctMatch: quiz.correctMatch,
          correctPuzzleGrid: quiz.correctPuzzleGrid,
          // imageQuestion: quiz.imageQuestion,
          QuestionScore: quiz.score,

          studentAnswerText: quiz.answerStudent
            ? quiz.answerStudent.answerText
            : null,
          studentAnswerMatch: quiz.answerStudent
            ? quiz.answerStudent.answerMatch
            : null,
          studentAnswerMemoryGame: quiz.answerStudent
            ? quiz.answerStudent.answerMemoryGame
            : null,
          studentAnswerPuzzleGrid: quiz.answerStudent
            ? quiz.answerStudent.answerPuzzleGrid
            : null,
          studentAnswer:
            quiz.answerStudent && quiz.answerStudent.answer !== null
              ? quiz.answerStudent.answer
              : null,
          studentIdState: quiz.answerStudent ? quiz.answerStudent._id : null,
          studentScore: quiz.answerStudent ? quiz.answerStudent.score : 0,
          divider: true,
          boolean: false,
        });
        this.totalQuestion = result.result.totalQuestion
        this.totalScore = result.result.totalScore
        this.questionInLib = result.result.questionInLib
        this.randomSetting = result.result.randomSetting
        // }
      });
      console.log(this.arrQuestion)
      this.pageCount_editScore = result.result.maxPage;
      this.articleDialogStatus = false
      this.article = ""
    },
    chekCorrectAnswer(idChioce, correctAnswer) {
      console.log(idChioce, correctAnswer)
      let check = false;
      for (let index = 0; index < correctAnswer.correctAnswer.length; index++) {
        const correct = correctAnswer.correctAnswer[index];
        if (correct== idChioce) {
          check = true;
          break;
        }
      }

      return check;
    },

    showAnswer(corrects, choices) {
      let correct_match = [];
      choices.filter(function (choice) {
        corrects.correct.forEach((correct) => {
          console.log(correct, choice._id)
          if (correct == choice._id) {
            correct_match.push(choice);
          }
        });
      });
      // this.correct_matchsome = answer[0];
      this.correct_matchsome = correct_match;
      // console.log("showAnswer -> this.correct_matchsome", this.correct_matchsome)
      this.correct_dialog = true;
    },

    async changePageEditScore() {
      this.arrTempScore = [];
      this.arrQuestion.forEach((arrq) => {
        this.arrTempScore.push({
          score: arrq.studentScore,
        });
      });
      await this.getQuestionListExam();
    },
  },
  async mounted() {
    // await this.initialize();
  },
};
</script>

<style scoped>
.incorrect-password{
  color: red
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}

td {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

th {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.custom-fix-width {
  min-width: 450px;
  max-width: 450px;
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
</style>

<style>
.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: none;
}
.search-input > .v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  /* padding: 0 12px; */
  min-height: 40px;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  height: 42px;
}
.text-field-border {
  border: 1px solid;
  /* border-radius: 8px; */
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  min-height: 40px;
  color: rgb(77, 77, 77);
}
.org-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.mb0 {
  margin-bottom: 0px;
}

/* .editor {
    height: 200px;
    margin-bottom: 70px;
  } */

.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  /* margin-top: 7%; */
  margin-top: 5px;
}

.headExplan {
  color: red;
  font-size: 20px;
  font-weight: bold;
}

.img {
  float: left;
  margin-right: 1rem;
}

.verticalLine {
  border-left: 3px solid #f5f5f5;
}

.rowCard {
  height: 400px;
  margin-top: 20px;
}

.titleCard {
  font-weight: bold;
  margin-top: 10px;
  color: rgb(0, 0, 0);
}

.logo {
  width: 20%;
  margin: 0 auto;
}

.login-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.paddingImg {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 60%;
  height: 60%;
}

.paddingCard {
  padding: 5px;
}

.center-div {
  margin: 0 auto;
}

/* .v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
      -webkit-transform: unset;
      transform: unset;
  } */
/* .item-card {
    width: 30%;
    min-height: 300px;
  } */
@media only screen and (max-width: 768px) {
  /* .item-card {
      width: 100%;
    } */
  .login-page {
    height: 100%;
    align-items: unset;
  }

  .v-application .pa-12 {
    padding: 10px !important;
  }
}

@media only screen and (min-width: 769px) and (max-width: 1024px) {
  /* .item-card {
      width: 60%;
      min-height: 560px;
    } */

  .login-page {
    height: 100%;
    align-items: center;
  }

  .v-application .pa-12 {
    padding: 10px !important;
  }
}
.correct {
  color: #4caf50;
  border: 1px solid #4caf50 !important;

  .check {
    position: absolute;
    left: 5px;
    top: 13px;

    i {
      color: #4caf50;
    }
  }

  p {
    color: #4caf50;
  }
}

.incorrect {
  color: #f44336;
  border: 1px solid #f44336 !important;

  .check {
    position: absolute;
    left: 5px;
    top: 13px;

    i {
      color: #f44336;
    }
  }

  p {
    color: #f44336;
  }
}

.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.selectCourse {
  height: auto;
}

.fixed-heght {
  height: 30px;
}

.rounded-card {
  border-radius: 8px;
}

/* .v-text-field--filled > .v-input__control > .v-input__slot,
  .v-text-field--full-width > .v-input__control > .v-input__slot,
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 40px;
  } */
.v-input__append-inner {
  margin-top: 9px !important;
}

.md-fixed-max-width {
  max-width: 200px;
}

.add-course .full-width {
  width: 100%;
}

.img-padding {
  display: flex;
  align-items: center;
  justify-content: center;
}

.apexcharts-toolbar {
  visibility: hidden;
  display: none;
}

.d-flex {
  display: flex;
}

@media only screen and (max-width: 768px) {
  .hiddex-xs {
    display: none;
  }

  .xs-full-max-width {
    max-width: 100%;
  }

  .md-fixed-width {
    width: 150px;
  }

  .xs-fixed-width {
    width: 100px;
  }

  .table-header {
    height: auto !important;
  }

  .table-header .v-toolbar__content {
    height: auto !important;
    flex-flow: column !important;
    padding: 0 !important;
  }

  .xs-full-width {
    width: 50%;
  }
}

.border-bottom {
  border-bottom: 1px solid #cfd8dc;
}

.border-bottom:last-child {
  border-bottom: none;
}

.full-width {
  width: 100%;
}

.filter-header {
  display: flex;
  justify-content: space-between;
}

.md-border {
  border: 1px solid #bdbdbd;
}

.text-caption {
  color: #9b9b9b;
  text-transform: uppercase;
}

.btn-reload {
  background: #ffffff !important;
  border: 1px solid #d9d9d9;
  color: rgb(77, 77, 77);
  box-shadow: none !important;
}

.hidden-md {
  display: none;
}

.main {
  background-color: rgb(241, 243, 245);
}

.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.button-danger {
  color: #ff5252 !important;
  border: 1px solid rgb(195, 195, 195);
}

.text-field-border {
  border: 1px solid;
  /* border-radius: 8px; */
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}

.title-text {
  color: rgb(140, 140, 140);
}

.text-primary {
  color: rgb(66, 154, 216) !important;
}

.have-border {
  border: thin solid #e4e4ee;
  border-radius: 4px;
}

.stat-num {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.stat-num-top {
  background-image: linear-gradient(rgba(#0779e4, 1), rgba(#0779e4, 0.7));
  color: white;
}

.stat-num-total {
  background-image: linear-gradient(rgba(#9f4355, 1), rgba(#9f4355, 0.7));
  color: white;
}

.stat-num-today {
  background-image: linear-gradient(rgba(#482f4d, 1), rgba(#482f4d, 0.7));
  color: white;
}

.stat-num-online {
  background-image: linear-gradient(rgba(#699ab2, 1), rgba(#699ab2, 0.7));
  color: white;
}

.stat-num-not-completed {
  background-image: linear-gradient(rgba(#ec0101, 1), rgba(#ec0101, 0.5));
  color: white;
}

.stat-num:hover {
  /* box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19); */
  /* background-color: rgba(#0779e4, 0.4); */
  transform: scale(1.05, 1.05);
}

.graph-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
  background-color: white;
  transition: transform 0.3s ease-in-out;
}

.graph-card:hover {
  /* box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19); */
  transform: scale(1.02, 1.02);
}

.v-application p {
  margin: 0 !important;
}

.number-border {
  /* padding: 5px; */
  width: 30px;
  height: 30px;
  position: relative;
}

.have-number-border {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  background: #bdbdbd87;
}

.number {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

p img {
  width: 100% !important;
}

.custom-icon {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  margin-top: 0;
}

.custom-number-panel {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}
.v-data-table.custom-table td {
  height: 0;
  padding: 0;
}

.v-data-table.custom-table td .backgroud-info {
  height: 48px;
  padding: 13px 0;
  border-bottom: 3px solid #2196f3;
}

.v-data-table.custom-table td .backgroud-success {
  height: 48px;
  padding: 13px 0;
  border-bottom: 3px solid #4caf50;
}

.v-data-table.custom-table td .backgroud-error {
  height: 48px;
  padding: 13px 0;

  border-bottom: 3px solid #f44336;
}

.v-data-table.custom-table td .backgroud-warning {
  height: 48px;
  padding: 13px 0;
  border-bottom: 3px solid #ffc107;
}

.v-data-table.custom-table thead tr th:nth-child(9) {
  border-bottom: 3px solid #ffc107 !important;
}

.v-data-table.custom-table thead tr th:nth-child(8) {
  border-bottom: 3px solid #f44336 !important;
}

.v-data-table.custom-table thead tr th:nth-child(7) {
  border-bottom: 3px solid #4caf50 !important;
}

.v-data-table.custom-table thead tr th:nth-child(6) {
  /*background: #B3E5FC !important;*/
  border-bottom: 3px solid #2196f3 !important;
}

.custom-question p {
  margin-bottom: 5px !important;
}

p > img {
  width: 100% !important;
}

.bg-sheet {
  background: #fafafa !important;
}

.pending-btn {
  padding: 7px;
  color: #fb8c00;
}
.article-title{
  font-size: 18px;
  margin-right: 10px;
}
</style>
<style lang="scss">
  .justify-content-right{
    justify-content: flex-end;
    height: 40px;
  }
  .exam-name-alert{
    font-size: 20px;
  }
  .overflow-unset {
    overflow-y: unset !important;
  }
  .card-color {
    background-color: #c2d7fd9c!important;
  }
</style>
